import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ctaClickEvent, pageViewEvent } from "../services/adobeDataLayer";

function Thankyou() {
  const navigate = useNavigate();
  useEffect(() => {
    //Trigger ADL on Thank you page load
    pageViewEvent("thank you");

    //Google Ads conversion event for icicibank-a2-homeloan-landingpage-submit
    if (typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-822902461/BT_-CJ2D8uwBEL39sYgD",
      });
    }
  }, []);

  const handleClick = () => {
    ctaClickEvent(
      "Back",
      "thank you page",
      "button",
      0,
      "https://campaigns.icici.bank.in/hl/homeLoan/ncaProductCalculator/index.html",
    );

    navigate("/");
  };

  return (
    <>
      {/* <Header /> */}
      <div className="container">
        <button onClick={handleClick} className="free_back thank_you_back">
          <img
            src={process.env.PUBLIC_URL + "/dist/img/back.svg"}
            width="12"
            alt="<"
          />
          Back
        </button>
      </div>
      '
      <article className="thank-you ">
        <div className="popup-icon">
          <img
            src={process.env.PUBLIC_URL + "/dist/img/call.png"}
            alt="tick"
            width={100}
            height={100}
            className="img-fluid"
          />
        </div>
        <div className="thankyou_txt">
          <h2>
            Thank you for your interest in ICICI Bank Home Loan. Our
            representative will get in touch with you from a number starting
            with 1600-XX-XXXX
            <br />
            <br />
          </h2>
          <h3 className="mt-3 fsmall">
            In the meantime, to learn more about
            <br className="br3" /> ICICI Bank Home Loan, please{" "}
            <a
              href="https://www.icicibank.com/personal-banking/loans/home-loan"
              target="_blank"
              rel="noreferrer"
              onClick={() => {
                ctaClickEvent(
                  "click here",
                  "thank you page",
                  "text link",
                  0,
                  "https://www.icicibank.com/personal-banking/loans/home-loan",
                );
              }}
            >
              click here.
            </a>
          </h3>
        </div>
      </article>
    </>
  );
}

export default Thankyou;
